<template>
    <div :class="$route.query.type >= 6 ? 'question-analyze another-show' : 'question-analyze'" v-if="inside">
        <span></span>
        <h5 class='title-direc'>{{$t('questionParsing')}}：</h5>
        <p v-html="inside"></p>
    </div>
</template>
<script>
export default {
  name: 'QuestionAnalyze',
  data () {
    return {
      quizType: this.$route.query.type
    }
  },
  props: {
    inside: {
      type: String
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.question-analyze{
    margin:10px 0 29px 0;
    padding:6px 25px;
    min-height:110px;
    background:#eef5fc;
    border-radius:3px;
    border:1px solid #005587;
    position:relative;
    &.another-show{
        padding:10px 54px;
        &::before{
            content:"参";
            display:block;
            width:26px;
            height:26px;
            border-radius:3px;
            background:#005587;
            color:#fff;
            font-weight:bold;
            position:absolute;
            left:15px;
            top:15px;
            text-align: center;
            line-height:26px;
        }
        .title-direc{
            display:none;
        }
    }
    span{
        display:block;
        width:15px;
        height:15px;
        border:1px solid #005587;
        position:absolute;
        left:54px;
        top:-9px;
        -webkit-transform:rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform:rotate(45deg) ;
        transform: rotate(45deg);
        background:#eef5fc;
        border-right:none;
        border-bottom:none;
    }
    .title-direc{
        color:#005587;
        font-size:18px;
        font-weight:bold;
        height:46px;
        line-height:46px;
    }
    p{
        line-height:25px;
    }
}
</style>
